import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  setDoc,
  serverTimestamp,
  increment,
} from "firebase/firestore";
import { useState } from "react";

// Initialize the secondary Firebase app
const secondaryAppConfig = {
  apiKey: "AIzaSyDsILOSKmO2GY7AwMIeZNjaUNkJhBttFag",
  authDomain: "hb-tec.firebaseapp.com",
  projectId: "hb-tec",
  storageBucket: "hb-tec.appspot.com",
  messagingSenderId: "416914585641",
  appId: "1:416914585641:web:179ca3a8da7047b1be8438",
  measurementId: "G-JRX3Y9QQ7F",
};

// Initialize Firebase and Firestore outside of the component
let secondaryApp;
let secondaryDb;

try {
  secondaryApp = initializeApp(secondaryAppConfig, "secondary");
  secondaryDb = getFirestore(secondaryApp);
} catch (error) {
  console.error("Error initializing secondary Firebase app:", error);
}

function BookDemoModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    secondaryContact: "",
    subject: "",
    message: "",
    meetingPlatform: "zoom",
    meetingTime: "",
    meetingDate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!secondaryDb) {
      alert("Error: Database connection not available");
      return;
    }

    try {
      // Create the consultation document
      const collectionRef = collection(secondaryDb, "MedcoRequests");
      const res = await addDoc(collectionRef, {
        ...formData,
        createdAt: serverTimestamp(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });

      onClose();
      alert("Demo booking submitted successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          <i className="fa fa-times"></i>
        </button>
        <h2>Book a Demo</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="secondaryContact"
              placeholder="Secondary Contact"
              value={formData.secondaryContact}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <div className="form-group">
            <select
              name="meetingPlatform"
              value={formData.meetingPlatform}
              onChange={handleChange}
              required
            >
              <option value="zoom">Zoom</option>
              <option value="teams">Microsoft Teams</option>
              <option value="meet">Google Meet</option>
            </select>
          </div>
          <div className="form-group">
            <input
              type="time"
              name="meetingTime"
              value={formData.meetingTime}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="date"
              name="meetingDate"
              value={formData.meetingDate}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default BookDemoModal;
